import { render, staticRenderFns } from "./ForumSubscriptionsView.vue?vue&type=template&id=a797a39e&"
import script from "./ForumSubscriptionsView.vue?vue&type=script&lang=js&"
export * from "./ForumSubscriptionsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports